import script from "./ProjectThemesAndBudget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectThemesAndBudget.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectThemesAndBudget.vue?vue&type=style&index=0&id=01d681be&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d681be"]])

export default __exports__